import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const features = ['Ceremonias de Unión', 'Ceremonias de Bienvenida al mundo y bendición de nombre', 'Ritual de cumpleaños', 'Ritual para Transiciones difíciles', 'Ritual para Cierre de ciclos', 'Ritual para Cierre de año e inicio de uno nuevo (con construcción de mapa de sueños)', 'Ritual para Atraer más abundancia', 'Ritual para Desarrollar tu intuición', 'Ritual para Construir y potenciar tu amor propio', 'Rituales para atravesar un duelo', 'Rituales de pareja para fortalecer el vínculo'];
  return <section className="relative bg-cream-light py-12 md:py-20 overflow-hidden" data-id="element-147">
      <div className="absolute top-0 left-0 w-full h-full opacity-30 pointer-events-none bg-[radial-gradient(#C4A265_1px,transparent_1px)] bg-[length:40px_40px]" data-id="element-148"></div>

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-149">
        <motion.div className="space-y-6 text-center" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-150">
          <div className="space-y-3" data-id="element-151">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-playfair font-bold leading-tight text-brown-dark" data-id="element-152">
              El Arte de Crear Espacios Sagrados
            </h1>
            <p className="text-lg md:text-xl font-lora text-brown-light leading-relaxed" data-id="element-153">
              Aprende a crear rituales y espacios sagrados que transforman tu
              vida, tu energía y tus momentos más importantes.
            </p>
          </div>

          <div className="rounded-sm overflow-hidden shadow-lg w-1/2 mx-auto" data-id="element-154">
            <img src="https://cdn.magicpatterns.com/uploads/8VcwhcCLTJ8Yy57XFexKP8/IMG_8432_1.webp" alt="Círculo de mujeres en ceremonia sagrada" className="w-full h-auto object-cover" fetchPriority="high" decoding="sync" data-id="element-155" />
          </div>

          <div className="space-y-3" data-id="element-156">
            <p className="font-lora text-brown-dark font-medium" data-id="element-157">
              Una guía profunda, práctica y amorosa para crear ceremonias,
              cerrar ciclos, sanar heridas emocionales y honrar momentos
              importantes de tu vida.
            </p>
            <p className="font-lora text-brown-light italic" data-id="element-158">
              Más de 200 páginas de rituales conscientes que podrás practicar
              sola, en pareja o en grupo.
            </p>
          </div>

          <ul className="space-y-2 inline-block text-left" data-id="element-159">
            {features.map((feature, index) => <li key={index} className="flex items-start gap-3" data-id="element-160">
                <CheckIcon className="w-5 h-5 text-gold-main flex-shrink-0 mt-0.5" data-id="element-161" />
                <span className="font-lora text-brown-dark" data-id="element-162">{feature}</span>
              </li>)}
          </ul>

          <div className="space-y-3 pt-2" data-id="element-163">
            <div className="flex items-baseline gap-2 justify-center" data-id="element-164">
              <span className="text-sm font-lora text-brown-light" data-id="element-165">
                Empieza hoy mismo por solo
              </span>
              <span className="text-3xl font-playfair font-bold text-gold-dark" data-id="element-166">
                $7.99 USD
              </span>
            </div>
            <CTAButton className="w-full md:w-auto" data-id="element-167">
              Quiero acceder al ebook ahora
            </CTAButton>
            <p className="text-xs font-lora text-brown-light flex items-center gap-1 justify-center" data-id="element-168">
              <span className="inline-block w-2 h-2 rounded-full bg-green-500" data-id="element-169"></span>
              Checkout seguro con Hotmart.
            </p>
          </div>
        </motion.div>

        {/* Book image — simplified glow for mobile performance */}
        <motion.div className="mt-10 relative max-w-xl mx-auto" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-170">
          <div className="absolute inset-0 bg-gold-main/15 blur-2xl rounded-full transform scale-90 hidden md:block" data-id="element-171"></div>
          <img src="https://cdn.magicpatterns.com/uploads/iwry5jWpKzBng5LRuRN5Xg/HERO_SECTION.webp" alt="Libro El Arte de Crear Espacios Sagrados" className="relative z-10 w-full h-auto object-contain drop-shadow-xl rounded-sm" fetchPriority="high" decoding="async" data-id="element-172" />
        </motion.div>
      </div>
    </section>;
}